module.exports = __webpack_public_path__ + "static/img/Tino-Fa’asuamaleaui.e1b2567.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tino-Fa’asuamaleaui.jpg
// module id = zjyp
// module chunks = 0